import { ApiError } from "@secretaa/sdk";
import type { TFunction } from "i18next";
import { errorMessage } from "../../shared/errors.ts";
const reasonKeys = {
  QUERY_INVALID: "projectQuery.errors.invalid", QUERY_LIMIT_EXCEEDED: "projectQuery.errors.limit", QUERY_FIELD_NOT_INDEXED: "projectQuery.errors.index",
  QUERY_RESOURCE_INACTIVE: "projectQuery.errors.inactive", QUERY_MANIFEST_CHANGED: "projectQuery.errors.changed", QUERY_CURSOR_INVALID: "projectQuery.errors.cursor",
  QUERY_CURSOR_STALE: "projectQuery.errors.stale", QUERY_TOO_COMPLEX: "projectQuery.errors.complex", QUERY_ACQUIRE_TIMEOUT: "projectQuery.errors.busy",
  QUERY_TIMEOUT: "projectQuery.errors.timeout", QUERY_DEPENDENCY_UNAVAILABLE: "projectQuery.errors.unavailable",
} as const;
export function queryError(t: TFunction, error: unknown) {
  const reason = error instanceof ApiError ? error.details?.reason : undefined;
  if (typeof reason === "string" && Object.hasOwn(reasonKeys, reason)) return t(reasonKeys[reason as keyof typeof reasonKeys]);
  if (error instanceof ApiError && error.code === "RATE_LIMITED") return t("projectQuery.errors.busy");
  return errorMessage(t, error);
}
